document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.site-header__mobile-toggle');
  var nav = document.getElementById('site-header-nav');

  // Sticky navbar spacer (2026-07-26): the navbar uses position: fixed
  // (see assets/header-navbar.css) rather than CSS position: sticky,
  // because Shopify wraps this section in its own auto-height grid row
  // (a <div class="shopify-section-group-header-group">, sized to
  // exactly the navbar's own height) — sticky's "stuck range" is bounded
  // by that wrapper, so it has zero room to operate and the navbar just
  // scrolls away after the first ~60px, as if sticky were never applied
  // at all (confirmed by direct measurement on the live page). position:
  // fixed has no such limitation, since it's always relative to the
  // viewport regardless of the wrapper's height — but taking the navbar
  // out of normal flow collapses that now-empty wrapper to 0 height,
  // which would yank all page content up by the navbar's height. This
  // reserves that exact space by setting the wrapper's min-height to the
  // navbar's own measured height, so nothing shifts.
  // Re-run on load (catches the logo <img> finishing loading late, which
  // can change the navbar's height after DOMContentLoaded already fired)
  // and on resize (padding/logo size can change across breakpoints).
  function setHeaderSpacerHeight() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var wrapper = header.closest('.shopify-section-group-header-group') || header.parentElement;
    if (!wrapper) return;
    wrapper.style.minHeight = header.getBoundingClientRect().height + 'px';
  }

  setHeaderSpacerHeight();
  window.addEventListener('load', setHeaderSpacerHeight);
  window.addEventListener('resize', setHeaderSpacerHeight);

  // Scroll lock: while the full-screen mobile menu is open, the page
  // behind it must not scroll at all — only the menu's own content
  // (already overflow-y: auto in CSS) should move. position:fixed on
  // <body>, restored to the exact prior scroll offset on close, is used
  // instead of a plain overflow:hidden because overflow:hidden alone
  // still lets iOS Safari's rubber-band/touch scrolling bleed through to
  // the page underneath a fixed overlay.
  var lockedScrollY = 0;

  function lockBodyScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockedScrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);

      if (isOpen) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });
  }

  document.querySelectorAll('.site-header__menu-item').forEach(function (item) {
    var link = item.querySelector('.site-header__menu-link');
    var submenu = item.querySelector('.site-header__submenu') || item.querySelector('.site-header__mobile-mega-grid');

    if (submenu && link) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth <= 989) {
          e.preventDefault();
          item.classList.toggle('is-open');
        }
      });
    }
  });

  // Safety net: if a menu link actually navigates away (or the user
  // resizes past the mobile breakpoint) while the menu was left open,
  // make sure body scroll is never left locked behind.
  document.querySelectorAll('#site-header-nav a').forEach(function (a) {
    a.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) {
        unlockBodyScroll();
      }
    });
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 989 && nav && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      unlockBodyScroll();
    }
  });
});
